import React from "react";

const RequestIcon = ({ width, height, color }) => {
  return (
    <svg
      width="31"
      height="40"
      viewBox="0 0 31 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.8333 2.66667C28.6853 2.66667 31 5.056 31 8C31 9.96746 29.9543 11.6693 28.4167 12.595V30.0729C29.9543 30.9974 31 32.6979 31 34.6667C31 37.6094 28.6853 40 25.8333 40C22.9813 40 20.6667 37.6094 20.6667 34.6667C20.6667 32.6979 21.7098 30.9974 23.25 30.0729V12.595C21.7098 11.6693 20.6667 9.96746 20.6667 8C20.6667 5.056 22.9813 2.66667 25.8333 2.66667ZM25.8333 37.3333C27.2587 37.3333 28.4167 36.1406 28.4167 34.6667C28.4167 33.1953 27.2587 32 25.8333 32C24.4042 32 23.25 33.1953 23.25 34.6667C23.25 36.1406 24.4042 37.3333 25.8333 37.3333ZM25.8333 10.6667C27.2587 10.6667 28.4167 9.47525 28.4167 8C28.4167 6.52475 27.2587 5.33333 25.8333 5.33333C24.4042 5.33333 23.25 6.52475 23.25 8C23.25 9.47525 24.4042 10.6667 25.8333 10.6667ZM2.58333 30.0729V13.3333C2.58333 5.3125 10.3333 5.33333 10.3333 5.33333H12.9167V0L20.6667 8L12.9167 16V10.6667C12.9167 10.6667 11.8394 10.6667 10.3333 10.6667C8.05524 10.6667 7.75 13.3333 7.75 13.3333V30.0729C9.2889 30.9974 10.3333 32.6953 10.3333 34.6667C10.3333 37.6094 8.01742 40 5.16667 40C2.31592 40 0 37.6094 0 34.6667C0 32.6979 1.04443 30.9974 2.58333 30.0729ZM5.16667 37.3333C6.59202 37.3333 7.75 36.1406 7.75 34.6667C7.75 33.1953 6.59202 32 5.16667 32C3.73877 32 2.58333 33.1953 2.58333 34.6667C2.58333 36.1406 3.73877 37.3333 5.16667 37.3333Z"
        fill="#fff"
      />
    </svg>
  );
};
export default RequestIcon;
